import {
	isNull, isUndefined, keyBy, indexOf,
} from 'lodash';
import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class ProjectService extends AbstractService {
	static setup(baseURL, options) {
		instance = new ProjectService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoint = APIEndpoints.projects;
	}

	static getAll(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getAll(...params);
	}

	static save(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._save(...params);
	}

	_getAll(queryParams) {
		return this.get({
			endpoint : this.endpoint,
			queryParams,
		});
	}

	_save({
		id,
		name,
		agencySupervisorName,
		description,
		secondaryAgencySupervisors,
		number : projectNo,
		clientSupervisor : clientSupervisorContactId,
		agencySupervisor : agencySupervisorContactId,
		paymentTerms : paymentTermsId,
		status : projectStatus,
		clientId,
	}) {
		const creating = isUndefined(id);
		const endpoint = `${this.endpoint}${!creating ? `/${id}` : ''}`;
		let secondaryProjectSupervisorModel = [];

		if (!isUndefined(secondaryAgencySupervisors)) {
			secondaryProjectSupervisorModel = keyBy(secondaryAgencySupervisors,
				(object) => indexOf(secondaryAgencySupervisors, object));
		}

		return this.request({
			endpoint,
			method : creating ? 'POST' : 'PUT',
			data   : {
				name,
				projectNo,
				clientSupervisorContactId,
				agencySupervisorContactId,
				agencySupervisorName,
				secondaryProjectSupervisorModel,
				paymentTermsId,
				description,
				projectStatus,
				clientId,
			},
		});
	}
}
